import Vue from 'vue'
import { Appointment } from '../entities/Appointment'
import { Course } from '../entities/Course'
import { AxiosResponse } from 'axios'

export class AppointmentsService {
  static getAppointmentsByCourseId (courseId:number, page:number, pageSize:number) {
    console.log('getAppointmentsByCourseId')
    return Vue.axios.get<Appointment[]>(`/appointments/course/${courseId}?page=${page}&pageSize=${pageSize}`)
      .then(response => {
        return response.data.map(item => {
          // Creating Appointment instance here
          return Appointment.newAppiontment(item.id,
            item.courseId,
            new Date(item.begin),
            new Date(item.end),
            item.availablePlaces,
            item.courseBookingList
          )
        })
      })
  }

  static getAppointmentById (appointmentId:number) {
    return Vue.axios.get<Appointment>(`/appointments/${appointmentId}`)
  }

  static transformDate (dateString: string): Date {
    const date = new Date(dateString)
    if (isNaN(date.getTime())) {
      console.error('Invalid date:', dateString)
      return new Date() // Or handle it as appropriate
    }
    return date // Return the valid Date object
  }
}
